<template>
    <div class="status-wrapper">
        <div class="container">
            <h1 class="status-title" v-if="certcourse">
                {{ $t('course_certificate_order') }}: {{ certcourse.course }}
            </h1>

            <h1 class="status-title" v-if="course">
                {{ $t('course_order') }}: {{ course.course }}
            </h1>

            <h1 class="status-title" v-if="subscription">
                {{ $t('buy_subscription') }}: {{ subscription.subscription }}
            </h1>

            <div class="ui-steeps mb-6">
                <ul class="ui-steeps__header">
                    <li class="ui-steep-header-item is-disabled">
                        <div class="ui-steep-header-item__text">
                            1. {{ $t('order') }}
                        </div>
                    </li>
                    <li class="ui-steep-header-item is-disabled">
                        <div class="ui-steep-header-item__text">
                            2. {{ $t('payment') }}
                        </div>
                    </li>
                    <li class="ui-steep-header-item is-active">
                        <div class="ui-steep-header-item__text">
                            3. {{ $t('payment_information') }}
                        </div>
                    </li>
                </ul>
            </div><!-- /.ui-steeps -->

            <div class="text-center">

                <div v-if="error">
                    <base-alert type="danger">{{error}}</base-alert>
                </div>

                <div v-if="paymentData.paystatus === 'succeeded'">
                    <h2 class="status-subtitle">
                        {{ $t('payment_succeeded') }}
                    </h2>
                    <div class="status-course">

                        <StudyPaymentStatus
                                v-if="subscription && subscription.studyProducts && subscription && subscription.studyProducts.length > 0"
                                :subscription="subscription"
                                :study-product="subscription.studyProducts[0]"
                        />

                        <p class="status-course__header" v-if="subscription && subscription.studyProducts === null">
                            {{ $t('go_to_timetable') }}:
                        </p>

                        <router-link
                                :data-payment-id="user_payment_id"
                                :data-id="subscription.idsubscription"
                                data-model="subscription"
                                :data-price="subscription.price"
                                data-action="payment-succeeded"
                                v-if="subscription && subscription.studyProducts === null"
                                class="status-course__link"
                                to="/user/profile/timetables"
                        >
                            {{ $t('my_timetables') }}
                        </router-link>

                        <p class="status-course__header" v-if="course">
                            {{ $t('go_to_full_course') }}:
                        </p>

                        <router-link
                                :data-id="course.idcourse"
                                :data-payment-id="user_payment_id"
                                data-model="course"
                                :data-price="course.price"
                                data-action="payment-succeeded"
                                v-if="course"
                                class="status-course__link"
                                :to="`/course/${course.slug}`"
                        >
                            {{course.course}}
                        </router-link>

                        <p class="status-course__header"
                           v-if="certcourse"
                           :data-payment-id="user_payment_id"
                           :data-id="certcourse.idcourse"
                           data-model="certificate"
                           :data-price="certcourse.price"
                           data-action="payment-succeeded"
                           v-html="$t('certificate_success_order')"
                        >

                        </p>

                        <div class="status-course__footer" v-if="!certcourse"
                             v-html="$t('course_success_order')"
                        >
                        </div>

                        <p class="status-course__notice px-lg-9 px-0" v-if="course">
                            {{ $t('course_order_notice') }}
                        </p>
                    </div>
                </div>

                <div v-else-if="paymentData.paystatus === 'canceled'">
                    <p style="color: red" v-html="$t('payment_error')">
                    </p>
                    <router-link v-if="certcourse" :to="certcourseBackUrl">{{ $t('to_certificate_payment') }} "{{certcourse.course}}"
                    </router-link>
                    <router-link v-if="course" :to="courseBackUrl">{{ $t('go_to_payment') }} {{course.course}}
                    </router-link>
                    <router-link v-if="subscription" :to="subscriptionBackUrl">
                        {{ $t('go_to_payment') }} {{subscription.subscription}}
                    </router-link>
                </div>

                <p v-else-if="paymentData.paystatus">
                    {{ $t('your_payment_status') }}: <b>{{paymentStatus[paymentData.paystatus]}}</b><br/>
                    <RippleLoader :color="'#5ab947'" :duration="'1.5s'"/>
                    <!-- Попробуйте обновить эту страницу через 1-2 минуты, чтобы увидеть изменения в статусе вашего платежа.<br/> -->
                </p>

                <div v-else-if="course && course.idcourse && courseAssigned">
                    <p>{{ $t('congrads_new_course') }}</p>
                    <p>{{ $t('go_to_full_course') }}:
                        <router-link :to="`/course/${course.slug}`">{{course.course}}</router-link>
                    </p>

                    {{ $t('all_order_available_at_account') }}

                    <p class="status-course__notice px-lg-9 px-0">
                        {{ $t('course_order_notice') }}
                    </p>
                </div>

                <div v-else-if="certcourse && certcourse.idcourse" v-html="$t('certificate_success_order')">
                </div>

                <div v-else-if="user_payment_id === 'free' && subscription" class="mb-8">

                    <StudyPaymentStatus
                            v-if="subscription && subscription.studyProducts && subscription && subscription.studyProducts.length > 0"
                            :subscription="subscription"
                            :study-product="subscription.studyProducts[0]"
                    />
                    <div v-else>
                        <p>{{ $t('congrads_new_subscriprion') }}</p>
                        <p style="margin-top: 40px">{{ $t('go_to_timetable') }}:
                            <router-link
                                    v-if="subscription"
                                    class="status-course__link"
                                    to="/user/profile/timetables">
                                {{ $t('my_timetables') }}
                            </router-link>
                        </p>

                        {{ $t('all_order_available_at_account') }}
                    </div>
                </div>

                <div v-else-if="!loading">
                    <p style="color: red">{{ $t('order_unavailable') }}</p>
                </div>

                <div v-else>
                    <p>{{ $t('loading') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import subscriprionApi from "../data/SubscriptionApi";
    import {RippleLoader} from 'vue-spinners-css';
    import GtmApi from "../data/GtmApi";
    import StudyPaymentStatus from "./Study/StudyPaymentStatus";

    export default {
        name: 'paymentstatus',
        props: ['user_payment_id'],
        components: {
            StudyPaymentStatus,
            RippleLoader,
        },
        data() {
            return {
                loading: true,
                paymentData: {},
                course: null,
                courseAssigned: false,
                paymentInfo: {},
                paymentStatus: {
                    pending: this.$t('payment_status_pending'),
                    waiting_for_capture: this.$t('payment_status_waiting_for_capture'),
                    succeeded: this.$t('payment_status_succeeded'),
                    canceled: this.$t('payment_status_canceled'),
                },
                subscription: null,
                error: null,
                certcourse: null,
            }
        },
        async mounted() {
            clearTimeout(this.timer)
            if (this.user_payment_id === 'free') {
                GtmApi.trackEventOnes(this.user_payment_id, {event: 'free-payment-event', category: "payment-cat"});
                if (this.$route.query.idcertcourse) {
                    let response = await axios({method: 'get', url: '/courses/' + this.$route.query.idcertcourse})
                    this.certcourse = response.data
                    this.loading = false
                }
                if (this.$route.query.idcourse) {
                    let response = await axios.get('user/profile?expand=userCourses')
                    const item = this.getBy('course_id', parseInt(this.$route.query.idcourse), response.data.userCourses)
                    this.courseAssigned = !!item.course_id
                    response = await axios({method: 'get', url: '/courses/' + this.$route.query.idcourse})
                    this.course = response.data
                    this.loading = false
                } else if (this.$route.query.idsubscription) {
                    this.fetchSubscription(this.$route.query.idsubscription)
                }
            } else {
                axios({method: 'get', url: '/payment/data?id=' + this.user_payment_id}).then(response => {
                    this.paymentData = response.data
                    if (this.paymentData['idcourse']) {
                        axios({method: 'get', url: '/courses/' + this.paymentData['idcourse']}).then(response => {
                            this.course = response.data
                        })
                    } else if (this.paymentData['idcertcourse']) {
                        axios({method: 'get', url: '/courses/' + this.paymentData['idcertcourse']}).then(response => {
                            this.certcourse = response.data
                        })
                    } else if (this.paymentData['idsubscription']) {
                        this.fetchSubscription(this.paymentData['idsubscription'])
                    }

                    if (this.paymentData.paystatus === "succeeded") {
                        GtmApi.trackEventOnes(this.user_payment_id, {event: 'payment-event', category: "payment-cat"});
                    }
                    if (this.paymentData.paystatus === "pending") {
                        this.timer = setInterval(() => {
                            this.$router.go(this.$router.currentRoute)
                        }, 15000)
                    }
                })

                /* Используется только статус, а он есть в this.paymentData.paystatus
                   Имеет смысл использовать этот метод, если на коллбэк данные приходят с опозданием,
                   но тогда будет рассогласование между данными на странице статуса и данными в базе
                axios({method: 'get', url: '/payment/info?id=' + this.user_payment_id}).then(response => {
                    this.paymentInfo = response.data
                    if (this.paymentInfo.status === "succeeded") {
                        if (this.$gtm) this.$gtm.trackEvent({event: 'payment', category: "payment"});
                    }
                })
                */
            }

        },

        computed: {
            subscriptionBackUrl() {
                if (this.subscription && this.subscription.stype === 'OnlineTeacher Group'
                    && this.paymentData && this.paymentData.timetable_id)
                    return `/subscription/payment/${this.subscription.idsubscription}/${this.paymentData.timetable_id}`

                if (this.subscription && (this.subscription.stype === 'OnlineTeacher Individual' || this.subscription.stype === 'OnlineTeacher Complex Individual')
                    && this.paymentData && !this.paymentData.timetable_id)
                    return `/subscription/payment/${this.subscription.idsubscription}`

                return null;
            },

            courseBackUrl() {
                if (this.course) {
                    if (this.paymentData && this.paymentData.addpack)
                        return `/payment/${this.course.idcourse}?${this.paymentData.addpack}`;

                    return `/payment/${this.course.idcourse}`;
                }

                return null;
            },

            certcourseBackUrl() {
                if (this.certcourse) {
                    return `/certificate/payment/${this.certcourse.idcourse}`;
                }

                return null;
            }
        },

        methods: {

            getBy(propname, value, array) {
                for (let index = 0; index < array.length; index++) {
                    if (array[index][propname] === value) return array[index]
                }

                return {}
            },

            fetchSubscription(idsubscription) {
                subscriprionApi.fetchSubscription(idsubscription)
                    .then(async response => {
                        this.subscription = response
                    })
                    .catch(error => {
                        let data = (error && error.response) ? error.response.data : {}
                        this.error = this.pretty(data)
                        this.loading = false
                    })
            },
        }
    };
</script>

<style src="@/assets/hometeacher/css/main.css">
</style>

